import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';
import moduleNavigation from 'cccisd-laravel-assignment/dist/components/navigations/withModules';
import courseWrapperCertificate from '../../pages/courseWrapper';
const navigations = [moduleNavigation, courseWrapper, courseWrapperCertificate];

export default navigations;
